<script setup>

import Link from "@/Components/Buttons/Link.vue";
import Html from "@/Components/Html.vue";

defineProps({
  content: String,
  buttons: Array,
});

const isHtml = (str) => {
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};

</script>

<template>
    <div class="inner-container my-15">
        <div class="prose mb-16 max-w-none">
            <Html
                v-if="isHtml"
                :html="content"
            />
            <p
                v-else
                v-text="content"
            />
        </div>
        <div class="grid gap-8">
            <Link
                v-for="button in buttons"
                :key="button.id"
                :label="button.label"
                :href="button.url"
            />
        </div>
    </div>
</template>
